jQuery(document).ready(function ($) {
    $("body").mousemove(function (event) {
        var pageCoords = "( " + event.pageX + ", " + event.pageY + " )";
        var clientCoords = "( " + event.clientX + ", " + event.clientY + " )";

        $(document).bind('mousemove.tiltObject', function (e) {
            var w = window.innerWidth;
            var h = window.innerHeight;
            var strength = 8;
            var x = e.pageX;
            var y = e.pageY;

            var offsetX = 0.5 - x / w,
                offsetY = 0.5 - y / h,
                dy = y - h / 2,
                dx = x - w / 2,
                theta = Math.atan2(dy, dx),
                angle = theta * 180 / Math.PI - 90,
                transform = 'translateY(' + -offsetX * strength + 'px) rotateX(' + (offsetY * strength * 2) + 'deg) rotateY(' + (-offsetX * (strength * 2)) + 'deg)';

            if (angle < 0) {
                angle = angle + 360;
            }

            $('#anmAbout').css('transform', transform);
        });
    });


    $('.count').counterUp({
        delay: 5,
        time: 1000
    });
});


(function ($) {
    var cat = document.querySelector("#follow");
    if (cat !== null && $(document).width() > 991) {
        var element = $('#follow'),
            originalY = element.offset().top;


        // Space between element and top of screen (when scrolling)
        var topMargin = 70;

        $(window).on('scroll', function (event) {

            var scrollTop = $(window).scrollTop();

            console.log(scrollTop);
            element.stop(true, true).animate({
                top: scrollTop < originalY
                    ? 0
                    : scrollTop - originalY + topMargin

            }, 0);
        });
    }
})(jQuery);